import React, { FC, ReactElement } from 'react'
import './employee-info.sass'
import { EmployeeInfoObject } from '../QuestionsPage'

interface EmployeeInfoProps {
  employeeInfo: EmployeeInfoObject
  openQuestionModal: any
}

const EmployeeInfo:FC<EmployeeInfoProps> = ({ employeeInfo, openQuestionModal }): ReactElement => {
  return (
    <div className="questions__employees__info">
      <div className="employee__photo ui-avatar">
        <img src={employeeInfo.photo} className="img-responsive" alt={employeeInfo.name}/>
      </div>
      <div className="employee__information">
        <div className="employee__name">
          {employeeInfo.name}
        </div>
        <div className="employee__position">
          {employeeInfo.post}
        </div>
        <button className="btn btn-primary btn--mobile-min bg-header" onClick={() => openQuestionModal(`${employeeInfo.name}`)}>
          Есть вопрос?
        </button>
      </div>
    </div>
  )
}

export default EmployeeInfo
